
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/downloadable-products",
      function () {
        return require("private-next-pages/account/downloadable-products.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/downloadable-products"])
      });
    }
  